import React from "react";

function TextWithLineBreaks(props) {
  // Check if props.text is a string
  if (typeof props.text !== "string") {
    return null; // or return <>{props.text}</> to render the content as-is
  }

  // Process the string with line breaks, but omit the last <br />
  const textWithBreaks = props.text.split("\n").map((text, index, array) => (
    <React.Fragment key={index}>
      {text}
      {index < array.length - 1 && <br />}{" "}
      {/* Only add <br /> if it's not the last line */}
    </React.Fragment>
  ));

  return <>{textWithBreaks}</>;
}

export default TextWithLineBreaks;
